'use strict';


export default class Layer {
    /**
     * @param {Boolean} state
     */
    constructor(state = false) {
        this.isShown = Boolean(state);
    }
    /**
     *
     */
    show() {
        this.isShown = true;
    }
    /**
     *
     */
    hide() {
        this.isShown = false;
    }
    /**
     *
     */
    toggle() {
        this.isShown = !this.isShown;
    }
}


// WEBPACK FOOTER //
// ./src/js/classes/Layer.js